import ar from './ar.json';
import en from './en.json';

/**
 * The Settings module's catalogue, registered from `app.config.tsx` under the
 * `settings` namespace — `shared/i18n` never imports a module (W2).
 *
 * It carries the copy for EVERY registry key, because the api sends i18n keys and
 * never copy (U8): `settings.<key>.label`, `.description`, and `.options.<value>`
 * for the option-shaped controls. A definition added on the api renders its raw key
 * here until this file gains its two lines — intended, visible debt rather than a
 * silent English fallback.
 */
export const settingsCatalogs = { ar, en };
